export default function() {
  return {
    categories: [],
    lists: [],
    category: {}
  }
}
